export function useJobRouteParams() {
  const route = useRoute()

  // Extracts jobTitleSlug and jobId from the route params, ensuring they are always strings even if the param is an array.
  const jobTitleSlug = Array.isArray(route.params.jobTitleSlug)
    ? route.params.jobTitleSlug[0]
    : route.params.jobTitleSlug as string
  const jobId = Array.isArray(route.params.jobId)
    ? route.params.jobId[0]
    : route.params.jobId as string

  return { jobTitleSlug, jobId }
}
